import VueRouter from 'vue-router'
import Vue from 'vue'
import home from '../view/home'
import download from '../view/download'
import feature from '../view/feature'
import explain from '../view/explain'
Vue.use(VueRouter)
const routes = [{
        path: '/home',
        component: home
    },
    {
        path: '/download',
        component: download
    },
    {
        path: '/feature',
        component: feature
    },
    {
        path: '/explain',
        component: explain
    },
    {
        path: '*',
        redirect: '/home'
    }
]
const router = new VueRouter({
    mode: 'hash',

    routes
})
export default router